import ZoneForm      from 'scripts/defa/zones/view-zone-form';
import template from 'scripts/defa/zones/template-zone-alias-form.jst.html';

/**
 * defa.views.ZoneAliasForm
 * A view for changing a zone alias.
 * @version 1.2.0
 * !TODO: Use settingsHome model when ready.
 */

const selectors = {
	zoneAliasInput: '[data-input=zone-alias]',
	temperatureAliasInput : '[data-input=temperature-alias]',
	buttonInfo: '[data-button=info-show]',
	divInfo   : '[data-info=alwaysOn-info]',
};

const ZoneAliasForm = ZoneForm.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		zoneAlias: selectors.zoneAliasInput,
		temperatureAlias: selectors.temperatureAliasInput,
		info : selectors.buttonInfo,
		infoText: selectors.divInfo,
	},
	
	events: {
		'click @ui.info'     : 'onClickedInfo',
	},
	
	templateContext: function(){
		return{
			zoneAlias : this.model.get('zone'+this.options.zoneNumber).zoneAlias || '',
			temperatureAlias : this.model.get('zone'+this.options.zoneNumber).temperatureAlias || '',
		}
	},

	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	/**
	 * Triggers wen the info button i clicked.
	 * Toggles the visibility of the div containing the information.
	 * @void
	 */
	onClickedInfo: function(event){
		event.preventDefault();
		this.ui.infoText.hasClass('hidden')
		? this.ui.infoText.removeClass('hidden')
		: this.ui.infoText.addClass('hidden');
	},
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Validates the form.
	 * @void
	 */
	validate: function(){
		let currentZoneAlias = this.model.get('zone'+this.options.zoneNumber).zoneAlias || '';
		let currentTemperatureAlias = this.model.get('zone'+this.options.zoneNumber).temperatureAlias || '';
		let maxLength = 24;
		return currentZoneAlias !== this.ui.zoneAlias.val().trim()
			   && this.ui.zoneAlias.val().trim().length <= maxLength ||
			   currentTemperatureAlias !== this.ui.temperatureAlias.val().trim()
			   && this.ui.temperatureAlias.val().trim().length <= maxLength;
	},
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		let zone = {
			enabled : this.model.get('zone'+this.options.zoneNumber).enabled,
			id : this.model.get('zone'+this.options.zoneNumber).id || null,
			temperatureAlias: this.ui.temperatureAlias.val().trim(),
			zoneAlias : this.ui.zoneAlias.val().trim(),
		};
		this.model.saveZone(zone, this.options.zoneNumber);
		this.trigger('close');
	},
	
} );


export default ZoneAliasForm;
